import { render } from "./MenuValueLinkDrop.vue?vue&type=template&id=4fdd3630&scoped=true"
import script from "./MenuValueLinkDrop.vue?vue&type=script&lang=js"
export * from "./MenuValueLinkDrop.vue?vue&type=script&lang=js"

import "./MenuValueLinkDrop.vue?vue&type=style&index=0&id=4fdd3630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdd3630"]])

export default __exports__